import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { type TrustProfileInfo, type Shop, type ShopGoogleReviews, type AdItem, AdvertiserType, UserProfileInfo, type UserAdInfo, type SearchResult } from '@sbt-web/network/types';
import { AdvertiserInfoPrivate } from './AdvertiserInfoPrivate';
import { AdvertiserInfoPro } from './AdvertiserInfoPro';
interface Props {
  item: AdItem;
  shop: Shop | null;
  shopGoogleReviews: ShopGoogleReviews | null;
  advertiserProfile: UserProfileInfo | null;
  trustInfo: TrustProfileInfo | null;
  showContactButton?: boolean;
  privateUserInfo?: UserAdInfo | null;
  userAds?: SearchResult | null;
}
const AdvertiserInfo: FC<Props> = t0 => {
  const $ = _c(12);
  const {
    shop,
    shopGoogleReviews,
    advertiserProfile,
    trustInfo,
    item,
    showContactButton: t1,
    privateUserInfo,
    userAds
  } = t0;
  const showContactButton = t1 === undefined ? false : t1;
  switch (item.advertiser.type) {
    case AdvertiserType.Private:
    case AdvertiserType.Company:
      {
        let t2;
        if ($[0] !== advertiserProfile || $[1] !== item || $[2] !== privateUserInfo || $[3] !== showContactButton || $[4] !== trustInfo || $[5] !== userAds) {
          t2 = <AdvertiserInfoPrivate advertiserProfile={advertiserProfile} trustInfo={trustInfo} item={item} showContactButton={showContactButton} privateUserInfo={privateUserInfo} userAds={userAds} />;
          $[0] = advertiserProfile;
          $[1] = item;
          $[2] = privateUserInfo;
          $[3] = showContactButton;
          $[4] = trustInfo;
          $[5] = userAds;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        return t2;
      }
    case AdvertiserType.Pro:
      {
        let t2;
        if ($[7] !== advertiserProfile || $[8] !== item || $[9] !== shop || $[10] !== shopGoogleReviews) {
          t2 = <AdvertiserInfoPro shop={shop} shopGoogleReviews={shopGoogleReviews} advertiserProfile={advertiserProfile} item={item} />;
          $[7] = advertiserProfile;
          $[8] = item;
          $[9] = shop;
          $[10] = shopGoogleReviews;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    default:
      {
        return null;
      }
  }
};
export default AdvertiserInfo;